function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BILLING_INVOICE_DETAILS_URL, BILLING_INVOICE_LIST_URL, FUTURE_INVOICE_DETAILS_URL, FUTURE_INVOICE_URL } from './components/billingPayments/billing.payments.constants';
import { CUSTOM_PAGE_STATE_NAME } from './components/customer/customPage/custom.page.config';
import { DETAIL_STATE_OR_NAME as CONTENT_ACTIVITY_PRODUCT_PAGE_REDIRECT, DEVICE_DETAIL_STATE_OR_NAME as CONTENT_ACTIVITY_DEVICE_PAGE_REDIRECT } from './components/customer/contentActivity/content.activity.config';
import { GRANTED_COUPON_ROUTE as GRANTED_COUPONS_PAGE_REDIRECT } from './components/customer/coupons/customer.coupons.config';
import { ACTIONS_STATE_NAME } from './components/customer/demoActions/demoActions.config';
import { STATE_OR_NAME as E_WALLET_PAGE } from './components/customer/ewallet/ewallet.config';
import { OFFERINGS_STATE_NAME } from './components/customer/offerings/offerings.config';
import { DISCONNECT_CUSTOMER_DBSS_ROUTE, DISCONNECT_OFFERS_DBSS_ROUTE } from './components/customer/offers/disconnect/dbss/disconnect.offers.dbss.config';
import { ORDER_HISTORY_DETAILS_STATE_NAME, ORDER_HISTORY_LIST_STATE_NAME } from './components/customer/orderHistory/order.history.config';
import { GROUP_ORDER_HISTORY_LIST_STATE_NAME } from './components/customer/orderHistory/orderHistoryListWrapper/order.history.list.wrapper.config';
import { TRANSFER_STATE_NAME } from './components/customer/orders/transfer/transfer.wizard.config';
import { REVIEW_STORE_ORDER_TRANSITION } from './components/customer/orders/transition/transition.offer.wizard.constants';
import { DETAIL_STATE_OR_NAME as PRODUCT_DETAILS_PAGE_REDIRECT } from './components/customer/products/products.config';
import { SERVICE_DETAILS_STATE_NAME } from './components/customer/servicesAndUsage/services.and.usage.config';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from './components/customer/servicesAndUsage/usageDetails/usage.details.config';
import { SUBSCRIPTION_DETAILS_ROUTE as SUBSCRIPTION_DETAILS_PAGE_REDIRECT, SUBSCRIPTION_REPLACE_ROUTE as SUBSCRIPTION_REPLACE_PAGE_REDIRECT } from './components/customer/subscriptions/subscriptions.config';
import { REDEEM_GIFT_ORDER_STATE_NAME } from './components/customer/redeemGiftOrder/redeem.gift.order.config';
import { LIST_STATE_OR_NAME as TRANSACTIONS_LIST_PAGE_REDIRECT, STATE_OR_NAME as TRANSACTIONS_PAGE_REDIRECT, TRANSACTION_DETAILS_STATE as TRANSACTIONS_DETAILS_PAGE_REDIRECT } from './components/customer/transactions/transactions.config';
import { ADD_OFFERING_INSTANCES, STATE_OR_NAME as ADD_OFFERING_PAGE, REVIEW_SAVED_CART, REVIEW_SAVED_CART_INSTANCES, REVIEW_STORE_ORDER_ADD } from './reducers/constants/add.offer.wizard.constants';
import { DASHBOARD_ROUTE, SUBSCRIPTION_LIST_ROUTE } from './reducers/constants/dashboard.constants';
import { EDIT_OFFERING_INSTANCES, STATE_OR_NAME as EDIT_OFFERING_PAGE, RECONNECT_OFFER_STATE_NAME, REVIEW_STORE_ORDER_EDIT } from './reducers/constants/edit.offer.wizard.constants';
import { GUEST_CHECKOUT, STATE_OR_NAME as NEW_CONNECT_PAGE } from './reducers/constants/new.connect.wizard.constants';
import { CREATE_PRODUCTS_ORDER_STATE_NAME } from './reducers/constants/products.wizard.constants';
import { STATE_OR_NAME as CHANGE_OFFERING_PAGE } from './reducers/constants/transition.offer.wizard.constants';
var CUSTOMER = '/customer/:customerId';
var ORDERING = "".concat(CUSTOMER, "/ordering");
var ACTIVITY = "".concat(CUSTOMER, "/activity");
export var HOME = '/';
export var SERVICES_AND_USAGES = "".concat(CUSTOMER, "/services-and-usages");
export var SERVICES = "".concat(SERVICES_AND_USAGES, "/services");
var ADDRESSES_STATE_REDIRECT = 'index.customercare.customer.addresses';
var RATE_SHEET_STATE_REDIRECT = 'index.customercare.customer.agreement';
var ACCOUNT_HIERARCHY_STATE_REDIRECT = 'index.customercare.customer.accountHierarchyRedirect';
export var ACCOUNT_HIERARCHY_NODE_SERVICES_PAGE_REDIRECT = 'index.customercare.customer.accountHierarchyNodeServicesRedirect';
export var E_WALLET_STATE_REDIRECT = 'index.customercare.customer.eWalletRedirect';
export var PROFILE_PAGE_REDIRECT = 'index.customercare.customer.profile';
export var HOUSEHOLD_PAGE_REDIRECT = 'index.customercare.customer.household';
export var CASES_LIST_STATE_REDIRECT = 'index.customercare.customer.casesRedirect';
export var RETRY_ACTIVATION_PAYMENT_STATE_REDIRECT = 'index.customercare.customer.retryActivationPaymentRedirect';
export var CASES_DETAILS_STATE_REDIRECT = 'index.customercare.customer.cases.detailsRedirect';
var INVOICE_MESSAGES_LIST_STATE_REDIRECT = 'index.customercare.customer.invoiceMessagesRedirect';
var INVENTORY_LIST_STATE_REDIRECT = 'index.customercare.customer.inventory';
var INTERACTIONS_LIST_STATE_REDIRECT = 'index.customercare.customer.interactionsRedirect';
var INTERACTIONS_DETAILS_STATE_REDIRECT = 'index.customercare.customer.interactions.detailRedirect';
var NOTIFICATIONS_LIST_STATE_REDIRECT = 'index.customercare.customer.notificationsRedirect';
export var INVENTORY_DETAILS_STATE_REDIRECT = 'index.customercare.customer.inventoryDetails';
export var PRICING_PLAN_EARLY_RENEWAL_REDIRECT = 'index.customercare.customer.pricingPlanEarlyRenewal';
export var DBSS_PRODUCT_DETAILS_PAGE_REDIRECT = 'index.customercare.customer.dbss-products.redirect';
export var SUSPEND_SUBSCRIBER_PRODUCTS_REDIRECT = 'index.customercare.customer.suspendSubscriberProducts.redirect';
export var RESUME_SUBSCRIBER_PRODUCTS_REDIRECT = 'index.customercare.customer.restoreSubscriberProducts.redirect';
export var SUSPEND_SERVICES_REDIRECT = 'index.customercare.customer.suspendServices.redirect';
export var RESUME_SERVICES_REDIRECT = 'index.customercare.customer.resumeServices.redirect';
export var USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT = 'index.customercare.customer.nonTelcoUsageServices.redirect';
export var SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE = 'index.customercare.customer.serviceAddonsOrdering';
export var INVENTORY_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE = 'index.customercare.customer.inventoryAddonsOrdering';
export var PRODUCT_LIST_PAGE_REDIRECT = 'index.customercare.customer.customerProducts.list';
export var SERVICES_USAGE_PAGE_REDIRECT = 'index.customercare.customer.servicesAndUsage';
export var MAKE_PAYMENT_PAGE_REDIRECT = 'index.customercare.customer.makePayment';
export var CONFIGURE_AUTOPAY_PAGE_REDIRECT = 'index.customercare.customer.configureAutopay';
export var AUTOPAY_PAGE_REDIRECT = 'index.customercare.customer.autoPay';
export var TREATMENT_DETAILS_PAGE_REDIRECT = 'index.customercare.customer.treatmentDetails';
export var TOTALS_PAGE_REDIRECT = 'index.customercare.customer.totals';
// devices.config.js declares the state inline and exports no name constant.
export var DEVICES_PAGE_REDIRECT = 'index.customercare.customer.devices';
// subscriptions.config.js exports the detail state name but declares the
// parent, remove and remove-extension states inline with no name constant.
export var SUBSCRIPTIONS_PAGE_REDIRECT = 'index.customercare.customer.subscriptions';
export var SUBSCRIPTION_REMOVE_PAGE_REDIRECT = 'index.customercare.customer.subscriptions.detail.remove';
export var SUBSCRIPTION_REMOVE_EXTENSION_PAGE_REDIRECT = 'index.customercare.customer.subscriptions.detail.extension';
// customer.coupons.config.js exports the granted-list and details state names but declares the
// parent and grant states inline with no name constant.
export var COUPONS_PAGE_REDIRECT = 'index.customercare.customer.coupons';
export var GRANT_COUPONS_PAGE_REDIRECT = 'index.customercare.customer.coupons.grantCoupons';
// content.activity.config.js exports the product and device state names but not the base one.
export var CONTENT_ACTIVITY_PAGE_REDIRECT = 'index.customercare.customer.contentActivity';
export var BILLING_PAYMENTS_PAGE_REDIRECT = 'index.customercare.customer.billingpayments';
export var BILLING_PAYMENTS_CREDIT_NOTE_PAGE_REDIRECT = 'index.customercare.customer.billingpayments.creditNote';
export var ASSOCIATE_SERVICES_REDIRECT = 'index.customercare.customer.associateservices';
var MODIFY_FDO_ACTION_TYPE = 'modify-future-dated-order';
export function getReactRoutes(_ref) {
  var _objectSpread2;
  var isNonTelcoUsageServicePageEnabled = _ref.isNonTelcoUsageServicePageEnabled,
    isContentActivityBetaEnabled = _ref.isContentActivityBetaEnabled,
    isCouponsBetaEnabled = _ref.isCouponsBetaEnabled,
    isDevicesBetaEnabled = _ref.isDevicesBetaEnabled,
    isBillingLedgerBetaEnabled = _ref.isBillingLedgerBetaEnabled,
    isRedeemGiftOrderFlowEnabled = _ref.isRedeemGiftOrderFlowEnabled,
    isSubscriptionChangeOrderFlowEnabled = _ref.isSubscriptionChangeOrderFlowEnabled,
    isSubscriptionsBetaEnabled = _ref.isSubscriptionsBetaEnabled,
    isTotalsBetaEnabled = _ref.isTotalsBetaEnabled,
    isTransactionsBetaEnabled = _ref.isTransactionsBetaEnabled,
    isDbss = _ref.isDbss,
    isReactHouseholdPageEnabled = _ref.isReactHouseholdPageEnabled,
    isReactCustomPageEnabled = _ref.isReactCustomPageEnabled;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, DASHBOARD_ROUTE, {
    url: "".concat(CUSTOMER, "/dashboard")
  }), ACCOUNT_HIERARCHY_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/account-hierarchy")
  }), ACCOUNT_HIERARCHY_NODE_SERVICES_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/account-hierarchy/:hierarchyId/node/:hierarchyNodeSubscriberId/services")
  }), ADDRESSES_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/addresses")
  }), CASES_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/cases")
  }), CASES_DETAILS_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/cases/:caseId/details")
  }), E_WALLET_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/e-wallet")
  }), INVOICE_MESSAGES_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing/invoice-messages")
  }), INVENTORY_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/inventory")
  }), INVENTORY_DETAILS_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/inventory/:inventoryId")
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, INTERACTIONS_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/interactions")
  }), INTERACTIONS_DETAILS_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/interactions/:interactionId")
  }), RETRY_ACTIVATION_PAYMENT_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/retry-activation-payment"),
    queryBuilder: function queryBuilder(params) {
      return {
        transactionDetails: params.transactionDetailsForRetryPayment
      };
    }
  }), ADD_OFFERING_INSTANCES, {
    url: "".concat(CUSTOMER, "/ordering/add-offering-instances/"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId,
        futureDatedOfferingId: params.futureDatedOfferingId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), EDIT_OFFERING_INSTANCES, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering-instances/:offeringId/:offeringInstanceId"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), REVIEW_SAVED_CART_INSTANCES, {
    url: "".concat(CUSTOMER, "/ordering/add-offering-instances?orderActionType=review-saved-cart")
  }), NEW_CONNECT_PAGE, {
    url: "".concat(HOME, "new-offering")
  }), GUEST_CHECKOUT, {
    url: "".concat(HOME, "new-offering?orderActionType=guest-checkout")
  }), ADD_OFFERING_PAGE, {
    url: "".concat(CUSTOMER, "/ordering/add-offering"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId,
        futureDatedOfferingId: params.futureDatedOfferingId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), REVIEW_SAVED_CART, {
    url: "".concat(CUSTOMER, "/ordering/add-offering?orderActionType=review-saved-cart")
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, REVIEW_STORE_ORDER_ADD, {
    url: "".concat(CUSTOMER, "/ordering/add-offering/checkout/resume-store-order")
  }), EDIT_OFFERING_PAGE, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering/:offeringId/:offeringInstanceId"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), REVIEW_STORE_ORDER_EDIT, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering/:offeringId/:offeringInstanceId/checkout/resume-store-order")
  }), REVIEW_STORE_ORDER_TRANSITION, {
    url: "".concat(CUSTOMER, "/ordering/change-offering/:offeringId/:offeringInstanceId/checkout/resume-store-order")
  }), CHANGE_OFFERING_PAGE, {
    url: "".concat(CUSTOMER, "/ordering/change-offering/:offeringId/:offeringInstanceId")
  }), DISCONNECT_OFFERS_DBSS_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/remove-offering/:offeringId/:offeringInstanceId")
  }), TRANSFER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/ordering/transfer-offerings")
  }), NOTIFICATIONS_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/notifications")
  }), GROUP_ORDER_HISTORY_LIST_STATE_NAME, {
    url: "".concat(CUSTOMER, "/order-history/group-orders")
  }), ORDER_HISTORY_LIST_STATE_NAME, {
    url: "".concat(CUSTOMER, "/order-history/orders")
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, ORDER_HISTORY_DETAILS_STATE_NAME, {
    url: "".concat(CUSTOMER, "/order-history/orders/:orderId")
  }), RATE_SHEET_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/agreement")
  }), PRICING_PLAN_EARLY_RENEWAL_REDIRECT, {
    url: "".concat(ORDERING, "/plan/early-renewal/:offeringInstanceId/:subscriberProductId?")
  }), DBSS_PRODUCT_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/products/details/:subscriberProductId")
  }), SUSPEND_SUBSCRIBER_PRODUCTS_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/suspend-subscriber-products/:offeringId/:offeringInstanceId")
  }), RESUME_SUBSCRIBER_PRODUCTS_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/restore-subscriber-products/:offeringId/:offeringInstanceId")
  }), SUSPEND_SERVICES_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/suspend-services/:serviceIdentifier?")
  }), RESUME_SERVICES_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/restore-services/:serviceIdentifier?")
  }), RECONNECT_OFFER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering/:offeringId/:offeringInstanceId/decisions/reconnect-offer-flow")
  }), DISCONNECT_CUSTOMER_DBSS_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/disconnect")
  }), _defineProperty(_defineProperty(_objectSpread2, E_WALLET_PAGE, {
    url: "".concat(CUSTOMER, "/e-wallet")
  }), PROFILE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/profile")
  })), isReactCustomPageEnabled ? _defineProperty({}, CUSTOM_PAGE_STATE_NAME, {
    url: "".concat(CUSTOMER, "/custom-page/:pageId")
  }) : {}), isReactHouseholdPageEnabled ? _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, HOUSEHOLD_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/household")
  }), "".concat(HOUSEHOLD_PAGE_REDIRECT, ".list"), {
    url: "".concat(CUSTOMER, "/household")
  }), "".concat(HOUSEHOLD_PAGE_REDIRECT, ".memberprivileges"), {
    url: "".concat(CUSTOMER, "/household/member-privileges/:subscriberId")
  }), ASSOCIATE_SERVICES_REDIRECT, {
    url: "".concat(CUSTOMER, "/household/associate-services")
  }) : {}), {}, _defineProperty(_defineProperty(_defineProperty({}, PRODUCT_LIST_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/products/list")
  }), PRODUCT_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/products/details/:lockerItemId")
  }), TREATMENT_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/treatment-details")
  }), isTransactionsBetaEnabled ? _defineProperty(_defineProperty(_defineProperty({}, TRANSACTIONS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing/transactions")
  }), TRANSACTIONS_LIST_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing/transactions"),
    queryBuilder: function queryBuilder(params) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, params.paymentInstrumentId ? {
        paymentInstrumentId: params.paymentInstrumentId
      } : {}), params.setPaymentFailureFilter ? {
        setPaymentFailureFilter: params.setPaymentFailureFilter
      } : {}), params.lockerItemId ? {
        lockerItemId: params.lockerItemId
      } : {}), params.productName ? {
        productName: params.productName
      } : {});
    }
  }), TRANSACTIONS_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing/transactions/:transactionId"),
    queryBuilder: function queryBuilder(params) {
      return _objectSpread({}, params.orderId ? {
        orderId: params.orderId
      } : {});
    }
  }) : {}), isTotalsBetaEnabled ? _defineProperty({}, TOTALS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing/totals")
  }) : {}), isDevicesBetaEnabled ? _defineProperty({}, DEVICES_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/devices")
  }) : {}), isSubscriptionsBetaEnabled ? _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SUBSCRIPTIONS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/subscriptions")
  }), SUBSCRIPTION_LIST_ROUTE, {
    url: "".concat(CUSTOMER, "/subscriptions")
  }), SUBSCRIPTION_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/subscriptions/:subscriptionId")
  }), SUBSCRIPTION_REMOVE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/subscriptions/:subscriptionId/remove/:childSubscriptionId?"),
    // The Angular state defaults childSubscriptionId to '' and squashes
    // it out of the URL; generatePath rejects an empty segment, so it
    // has to be dropped rather than passed through.
    params: function params(_params) {
      return _objectSpread({
        customerId: _params === null || _params === void 0 ? void 0 : _params.customerId,
        subscriptionId: _params === null || _params === void 0 ? void 0 : _params.subscriptionId
      }, _params !== null && _params !== void 0 && _params.childSubscriptionId ? {
        childSubscriptionId: _params.childSubscriptionId
      } : {});
    }
  }), SUBSCRIPTION_REMOVE_EXTENSION_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/subscriptions/:subscriptionId/remove-extension/:extensionId/:currency")
  }) : {}), isSubscriptionChangeOrderFlowEnabled ? _defineProperty({}, SUBSCRIPTION_REPLACE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/subscriptions/:subscriptionId/replace/:childSubscriptionId?"),
    // childSubscriptionId is a ui-router query param on the Angular
    // state and an optional segment on the React route, so it is
    // absent for a subscription-level replace. generatePath rejects
    // an empty segment, so it has to be dropped rather than passed
    // through.
    params: function params(_params2) {
      return _objectSpread({
        customerId: _params2 === null || _params2 === void 0 ? void 0 : _params2.customerId,
        subscriptionId: _params2 === null || _params2 === void 0 ? void 0 : _params2.subscriptionId
      }, _params2 !== null && _params2 !== void 0 && _params2.childSubscriptionId ? {
        childSubscriptionId: _params2.childSubscriptionId
      } : {});
    }
  }) : {}), isRedeemGiftOrderFlowEnabled ? _defineProperty({}, REDEEM_GIFT_ORDER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/redeem-gift-order")
  }) : {}), isCouponsBetaEnabled ? _defineProperty(_defineProperty(_defineProperty({}, COUPONS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/coupons")
  }), GRANTED_COUPONS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/coupons")
  }), GRANT_COUPONS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/coupons/grant-coupons")
  }) : {}), isContentActivityBetaEnabled ? _defineProperty(_defineProperty(_defineProperty({}, CONTENT_ACTIVITY_PAGE_REDIRECT, {
    url: "".concat(ACTIVITY, "/content-activity")
  }), CONTENT_ACTIVITY_PRODUCT_PAGE_REDIRECT, {
    url: "".concat(ACTIVITY, "/content-activity/product/:productId")
  }), CONTENT_ACTIVITY_DEVICE_PAGE_REDIRECT, {
    url: "".concat(ACTIVITY, "/content-activity/device/:deviceId")
  }) : {}), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, OFFERINGS_STATE_NAME, {
    url: "".concat(CUSTOMER, "/offerings/:offeringInstanceId?")
  }), SERVICE_DETAILS_STATE_NAME, {
    url: "".concat(SERVICES, "/:serviceIdentifier")
  }), SERVICES_USAGE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/services-and-usages/services")
  }), SERVICE_USAGE_DETAILS_STATE_NAME, {
    url: "".concat(SERVICES_AND_USAGES, "/usage-details"),
    queryBuilder: function queryBuilder(params) {
      return {
        allEntitlements: params.allEntitlements,
        searchBy: params.searchBy,
        searchParams: JSON.stringify({
          UsageStatementId: params.statementId
        }),
        serviceAttributeId: params.serviceAttributeId,
        serviceIdentifierValue: params.serviceIdentifierValue,
        tab: params.tab
      };
    }
  }), isNonTelcoUsageServicePageEnabled ? _defineProperty({}, USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT, {
    url: "".concat(SERVICES_AND_USAGES, "/usage-details-finance"),
    queryBuilder: function queryBuilder(params) {
      return {
        serviceIdentifierValue: params.serviceIdentifierValue
      };
    }
  }) : {}), {}, _defineProperty(_defineProperty(_defineProperty({}, SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/service-feature-products/:serviceIdentifierValue/:serviceId/service-add-ons/:serviceAttributeId")
  }), INVENTORY_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/service-feature-products/:serviceIdentifierValue/:serviceId/inventory-add-ons/:inventoryDisplayName")
  }), MAKE_PAYMENT_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/make-payment/:account?"),
    params: function params(_params3) {
      return _objectSpread(_objectSpread({}, _params3 !== null && _params3 !== void 0 && _params3.account ? {
        account: _params3 === null || _params3 === void 0 ? void 0 : _params3.account
      } : {}), {}, {
        customerId: _params3 === null || _params3 === void 0 ? void 0 : _params3.customerId
      });
    },
    queryBuilder: function queryBuilder(params) {
      return _objectSpread(_objectSpread({}, params !== null && params !== void 0 && params.invoiceNumber ? {
        invoiceNumber: params.invoiceNumber
      } : {}), params.paymentType ? {
        paymentType: params.paymentType
      } : {});
    }
  }), isBillingLedgerBetaEnabled ? _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BILLING_PAYMENTS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing-payments")
  }), BILLING_INVOICE_LIST_URL, {
    url: "".concat(CUSTOMER, "/billing-payments")
  }), BILLING_INVOICE_DETAILS_URL, {
    url: "".concat(CUSTOMER, "/billing-payments/invoice-details/:invoiceId"),
    queryBuilder: function queryBuilder(params) {
      return params.returnTab ? {
        returnTab: params.returnTab
      } : {};
    }
  }), BILLING_PAYMENTS_CREDIT_NOTE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing-payments/adjustment-details/:creditNoteId"),
    queryBuilder: function queryBuilder(params) {
      return params.returnTab ? {
        returnTab: params.returnTab
      } : {};
    }
  }), FUTURE_INVOICE_URL, {
    url: "".concat(CUSTOMER, "/billing-payments/future-invoices")
  }), FUTURE_INVOICE_DETAILS_URL, {
    url: "".concat(CUSTOMER, "/billing-payments/future-invoices/:invoiceId")
  }) : {}), isDbss ? _defineProperty({}, CREATE_PRODUCTS_ORDER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/ordering/create-product-order")
  }) : {}), {}, _defineProperty(_defineProperty(_defineProperty({}, ACTIONS_STATE_NAME, {
    url: "".concat(CUSTOMER, "/demo-actions")
  }), AUTOPAY_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/configure-autopay")
  }), CONFIGURE_AUTOPAY_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/configure-autopay")
  }));
}
;